import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import GS from '../grafsync/grafsync';
import { globalStyles as styles } from './style/gstheme';
import { Typography } from '@material-ui/core';

const TIME_PERIOD = 100;

class Unsaved extends React.Component {

  state = {
    startEdits: GS.outstandingEdits(),
    edits: GS.outstandingEdits()
  };

  componentDidMount() {
    this.hcTimeout = setTimeout(() => this.isStillSaving(), TIME_PERIOD);
  }

  isStillSaving = () => {
    const edits = GS.outstandingEdits();
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    this.setState({ edits });
    if (edits > 0) {
      this.hcTimeout = setTimeout(() => this.isStillSaving(), TIME_PERIOD);
    }
    else {
      if (this.props.onDone) this.props.onDone(this.props.continue);
    }
  };

  componentWillUnmount() {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  render() {

    const { classes } = this.props;
    const { edits, startEdits } = this.state;

    return (
      <React.Fragment>
        <Dialog 
          data-test="unsaved-dialog"
          open={edits > 0}
          aria-labelledby="unsaved-dialog-title" >
          <DialogTitle
            disableTypography
            className={classes.mainHeading}
            id="unsaved-dialog-title">Processing Unsaved Edits</DialogTitle>
          <DialogContent style={{ height: '150px' }}>
            <DialogContentText className={classes.dialogText}>Please wait. All edits must be processed first to avoid losing data.</DialogContentText>
            <Typography data-test="edit-count" className={classes.mainHeading} style={{ textAlign: 'center', }}>{edits} more to go</Typography>
            <LinearProgress color="secondary" className={classes.progress} variant="determinate" value={(startEdits - edits) / startEdits * 100} />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

Unsaved.defaultProps = {
  continue: false
};

Unsaved.propTypes = {
  onDone: PropTypes.func,
  continue: PropTypes.bool,
  classes: PropTypes.object
};

export default withStyles(styles)(Unsaved);